import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/CarrierProgram/";

export const getCarrierPrograms = () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res.data;
  });
};

export const addCarrierProgram = async (newData) => {
  return await axios.post(`${api_base_url}`, newData[0]);
};

export const editCarrierProgram = async (updatedData) => {
  return await axios.put(`${api_base_url}`, {
    ...updatedData,
  });
};

// Deactivate CarrierProgram
export const deleteCarrierProgram = async (ids) => {
  return await axios.delete(`${api_base_url}`, {
    data: ids,
  });
};
